import * as React from "react"
import AccountCircleIcon from "@mui/icons-material/AccountCircle"
import { CircularProgress, Container, Paper, TextField } from "@mui/material"
import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"
import { Button, Grid, AppBar, Toolbar } from "@mui/material"
import { useSearchParams } from "react-router-dom"
import Modal from "react-bootstrap/Modal"
import HelpIcon from "@mui/icons-material/Help"
import { useOutletContext } from "react-router-dom/dist"
import { useParams } from "react-router-dom"
import { useState } from "react"
import useApi from "../hooks/useApi"
import { useEffect } from "react"
import { toast } from "react-toastify"
import { useDispatch } from "react-redux"
import { Helmet } from "react-helmet"
import apiClient from "../api/apiClient"
import Paginate from "../components/mui/Paginate"
import ShopFilterSidebar from "../components/sidebar-filter/ProductFilterSidebar"
import Calender from "../components/mui/Calendar"
import { formatDate, objectToQueryString } from "../modules/helpers"
import LoadingOverlay from "../components/mui/LoadingOverlay"
import downloadFile from "../modules/downloadFile"
import OptionsMenus from "../components/core/OptionsMenu"
import { showModal } from "../redux/modalSlice"
import SelectOption from "../components/mui/SelectOption"
import axios from "axios";
import ReportDownloadModal from "../components/ReportDownloadModal"

const baseURL = process.env.REACT_APP_BASE_URL
const SubmittedReport = () => {
  const [searchParams, setSearchParams] = useSearchParams(); // <-- Initialize hook

  // 1. Initialize state directly from the URL if it exists
  const urlPage = parseInt(searchParams.get("page")) || 1;
  const initialFilters = {
    start_date: searchParams.get("start_date") || "",
    end_date: searchParams.get("end_date") || "",
    date_search_type: searchParams.get("date_search_type") || "client",
    keyword: searchParams.get("keyword") || "barcode",
    search: searchParams.get("search") || "",
    archive: searchParams.get("archive") === "true", // Handle boolean conversion from URL string
  };

  const [count, setCount] = useState(0);
  const [page, setPage] = useState(urlPage); // Keep track of current page locally
  const [showFilter, setShowFilter] = useState(false);
  const [reset, setReset] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [reportDownloadBarcode, setReportDownloadBarcode] = useState("");

  const [showModalReAssign, setShowModalReAssign] = useState(false);
  const [showRecSampleMDL, setShowRecSampleMDL] = useState(false);
  const [selectedSample, setSelectedSample] = useState("");

  const [filters, setFilters] = useState(initialFilters);
  const [date, setDate] = useState(
    initialFilters.start_date && initialFilters.end_date
      ? [initialFilters.start_date, initialFilters.end_date]
      : []
  );

  const { request, error, data, loading } = useApi((route) => apiClient.get(route));
  // console.log(data, "fghu data");

  const onReset = () => {
    setFilters({
      start_date: "",
      end_date: "",
      date_search_type: "client",
      keyword: "barcode",
      search: "",
      archive: false,
    });
    setDate([]);
    setPage(1);
    setSearchParams({}); // <-- Clear the URL completely
    setReset(true);
  };

  const onFilterChange = (key, value) => {
    setFilters({ ...filters, [key]: value });
  };

  useEffect(() => {
    if (reset) fetchData(1);
  }, [reset]);

  const fetchData = async (currentPage = page) => {
    // Collect raw filter inputs
    const filterObject = {
      start_date: date?.[0] || "",
      end_date: date?.[1] || "",
      date_search_type: filters.date_search_type,
      archive: filters.archive,
      keyword: filters.keyword,
      search: filters.search,
    };

    // 2. Update the URL parameters with current state
    const params = new URLSearchParams();
    if (filterObject.start_date) params.set("start_date", filterObject.start_date);
    if (filterObject.end_date) params.set("end_date", filterObject.end_date);
    if (filterObject.date_search_type !== "client") params.set("date_search_type", filterObject.date_search_type);
    if (filterObject.keyword !== "barcode") params.set("keyword", filterObject.keyword);
    if (filterObject.search) params.set("search", filterObject.search);
    if (filterObject.archive) params.set("archive", filterObject.archive); // stores "true" if true
    if (currentPage > 1) params.set("page", currentPage);

    setSearchParams(params); // Pushes the new query string to the URL
    setPage(currentPage); // Sync local page state

    // 3. Construct API query payload
    const apiQueryObject = {
      start_date: filterObject.start_date,
      end_date: filterObject.end_date,
      date_search_type: filterObject.date_search_type,
      archive: filterObject.archive,
      [filterObject.keyword]: filterObject.search,
    };

    if (currentPage === 1 && count) setCount(0);
    
    const result = await request(
      `/sample/?limit=10&page=${currentPage}&${objectToQueryString(apiQueryObject)}`
    );
    
    setReset(false);
    
    // Make sure result exists before trying to read count
    if (result && result.data) {
      if (!count || currentPage === 1 || count !== result.data.count) {
        setCount(result.data.count);
      }
    }
  };

  const handlePageChange = (event, value) => {
    fetchData(value);
  };

  useEffect(() => {
    fetchData(page); // Start the fetch with the page initialized from the URL
  }, []);

  const openReportDownloadModal = (barcode) => {
    setReportDownloadBarcode(barcode)
  }

  const closeReportDownloadModal = () => {
    if (!isDownloading) setReportDownloadBarcode("")
  }

  const handleDownload = async (regenerate) => {
    const barcode = reportDownloadBarcode
    if (!barcode) return

    setIsDownloading(true);
    try {
      const token = localStorage.getItem("token")
      const response = await axios.get(`${baseURL}report/download/${barcode}`, {
        responseType: "blob", // Important for handling binary data (PDF)
        headers: {
          Accept: "application/pdf",
          ...(token ? { Authorization: `Bearer ${token}` } : {})
        },
        timeout: 60000, // Optional: Set timeout for large files
        params: regenerate ? { regenerate: true } : {},
      });

      if (response.status !== 200) {
        throw new Error("Failed to download");
      }

      const blob = new Blob([response.data], { type: "application/pdf" });
      console.log("Blob size:", blob.size);

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = `report_${barcode}.pdf`;
      document.body.appendChild(a);
      a.click();

      // Cleanup
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      }, 60000);
    } catch (error) {
      console.error("Download error:", error);
      toast.error("Failed to download the report");
    } finally {
      setIsDownloading(false);
      setReportDownloadBarcode("");
    }
  };

  const handleReAssignSample = (data) => {
    setShowModalReAssign(true);
    setSelectedSample(data);
  };
  return (
    <div>
      <Helmet>
        <title>Reports</title>
      </Helmet>
      <LoadingOverlay open={isDownloading && !reportDownloadBarcode} />
      <Container maxWidth={false} sx={{ maxWidth: 1180, px: { xs: 2, md: 3 } }}>
        <div className="d-flex justify-content-between">
          <div>
            <ShopFilterSidebar
              openFilter={showFilter}
              onOpenFilter={() => setShowFilter(true)}
              onCloseFilter={() => setShowFilter(false)}
              handleChange={onFilterChange}
              values={filters}
              onReset={onReset}
             fetchData={() => fetchData(1)}
              date={date}
              setDate={setDate}
            />
          </div>
          <div>
            <Button
              sx={{ borderRadius: 20, whiteSpace: "nowrap" }}
              className="btn_bg_secondery"
              variant="contained"
              onClick={() => {
                setShowRecSampleMDL(true)
              }}>
              Receive New Sample
            </Button>
          </div>
        </div>
      </Container>
      <Container maxWidth={false} sx={{ maxWidth: 1180, px: { xs: 2, md: 3 } }}>
      <Grid container>
        <Grid className=" d-flex justify-content-center" container item md={12} xs={12}>
          <Grid item xs={12}>
            <h5 className="my-3">Reports data:</h5>
            {!loading ? (
              <>
                {data.map((item, index) => {
                  const { client, technician, sampleStatus, ...otherSampleItem } = item

                  return (
                    <div
                      className=" row justify-content-center d-flex gy-2 gx-2 flex-wrap px-4 mb-5"
                      style={{
                        backgroundColor: "#F1F1F5",
                        // color:"white",
                        borderRadius: 15,
                        alignItems: "center",
                        paddingTop: 40,
                        paddingBottom: 40
                      }}>
                      <div className="col-1 d-flex align-items-start h-100">
                        <AccountCircleIcon fontSize="large" />
                      </div>
                      <div className="col-md-8">
                        <div className="row flex-wrap">
                          {/* First set of information */}

                          <div className="col-6">
                            <Typography
                              className="fs_14"
                              variant="body2"
                              sx={{ fontWeight: "bold" }}>
                              Name:
                            </Typography>
                            <Typography className="fs_10px" sx={{ fontWeight: "bold" }}>
                              {client.firstname + " " + client.lastname}
                            </Typography>
                          </div>

                          <div className="col-6">
                            <Typography
                              className="fs_14"
                              variant="body2"
                              sx={{ fontWeight: "bold" }}>
                              Address:
                            </Typography>
                            <Typography className="fs_10px">{client.address}</Typography>
                          </div>

                          {/* Second set of information */}
                          <div className="col-6">
                            <Typography variant="body2" component="p" sx={{ fontWeight: "bold" }}>
                              Email
                            </Typography>
                            <Typography variant="body2" component="p" sx={{ fontSize: "0.7rem" }}>
                              {client.email}
                            </Typography>
                          </div>

                          <div className="col-6">
                            <Typography variant="body2" component="p" sx={{ fontWeight: "bold" }}>
                              Contact
                            </Typography>
                            <Typography variant="body2" component="p" sx={{ fontSize: "0.7rem" }}>
                              {client.phone_no}
                            </Typography>
                          </div>

                          {/* Third set of information */}
                          <div className="col-6">
                            <Typography variant="body2" component="p" sx={{ fontWeight: "bold" }}>
                              Pet Name
                            </Typography>
                            <Typography variant="body2" component="p" sx={{ fontSize: "0.7rem" }}>
                              {client.pet.pet_name}
                            </Typography>
                          </div>

                          <div className="col-6">
                            <Typography variant="body2" component="p" sx={{ fontWeight: "bold" }}>
                              Barcode
                            </Typography>
                            <Typography variant="body2" component="p" sx={{ fontSize: "0.7rem" }}>
                              {client.barcode}
                            </Typography>
                          </div>
                          <div className="col-6">
                            <Typography variant="body2" component="p" sx={{ fontWeight: "bold" }}>
                              Client Register Date
                            </Typography>
                            <Typography variant="body2" component="p" sx={{ fontSize: "0.7rem" }}>
                              {formatDate(client?.createdAt, "MMMM D, YYYY [at] h:mma")}
                            </Typography>
                          </div>
                          <div className="col-6">
                            <Typography variant="body2" component="p" sx={{ fontWeight: "bold" }}>
                              Sample Receive Date
                            </Typography>
                            <Typography variant="body2" component="p" sx={{ fontSize: "0.7rem" }}>
                              {formatDate(otherSampleItem?.createdAt, "MMMM D, YYYY [at] h:mma")}
                            </Typography>
                          </div>
                          <div className="col-6">
                            <Typography variant="body2" component="p" sx={{ fontWeight: "bold" }}>
                              Report Create Date
                            </Typography>
                            <Typography
                              variant="body2"
                              component="p"
                              sx={{
                                color: otherSampleItem?.submitted_at ? "inherit" : "text.secondary",
                                fontSize: "0.7rem"
                              }}>
                              {otherSampleItem?.submitted_at
                                ? formatDate(
                                    otherSampleItem?.submitted_at,
                                    "MMMM D, YYYY [at] h:mma"
                                  )
                                : "Not generated yet"}
                            </Typography>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3 d-flex flex-column flex-sm-row">
                        <Box className="">
                          <Typography
                            className="fs_14px"
                            variant="span"
                            sx={{ display: "block", ml: 1, fontWeight: "bold" }}>
                            Technician name
                          </Typography>
                          <Typography
                            className="fs_14px"
                            variant="span"
                            sx={{ display: "block", ml: 1 }}>
                            {technician?.name}
                          </Typography>
                          {/* <Button
                          sx={{}}
                          onClick={() => handleDownload(client.barcode)}
                          disabled={sampleStatus !== "SUB"}
                          className=" m-2 btn btn_bg_secondery"
                          variant="contained"
                        >
                          Generate Report
                        </Button>
                        <Button
                          sx={{}}
                          component={Link}
                          to={`/get-report/${client.barcode}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          disabled={sampleStatus !== "SUB"}
                          className=" m-2 btn btn_bg_secondery"
                          variant="contained"
                        >
                          View Report
                        </Button> */}
                          <OptionsMenus
                            handleReportGenerate={() => openReportDownloadModal(client.barcode)}
                            reportViewHref={`/get-report/${client.barcode}`}
                            handleReAssignTechnician={() => handleReAssignSample(item)}
                            reportButtonsDisable={sampleStatus !== "SUB"}
                          />
                        </Box>
                      </div>
                    </div>
                  )
                })}
              </>
            ) : (
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <CircularProgress />
              </Box>
            )}
            <div className={`${loading && "d-none"}`}>
              <Paginate style={{ color: "white" }} count={count} page={page} onChange={handlePageChange} />
            </div>
          </Grid>
        </Grid>
      </Grid>
      </Container>

      {showModalReAssign && (
        <ReAssignModal
          show={showModalReAssign}
          onHide={() => setShowModalReAssign(false)}
          data={selectedSample}
          fetchData={fetchData}
        />
      )}
      {/* {showModalReAssign && ( */}
      <AssignModal
        show={showRecSampleMDL}
        onHide={() => setShowRecSampleMDL(false)}
        // data={selectedSample}
        fetchData={fetchData}
      />
      <ReportDownloadModal
        show={Boolean(reportDownloadBarcode)}
        onHide={closeReportDownloadModal}
        onSelect={handleDownload}
        loading={isDownloading}
      />
      {/* )} */}
    </div>
  )
}

function AssignModal({ fetchData, onHide, show }) {
  let initialstate = {
    technician: "",
    barcode: ""
  }
  const dispatch = useDispatch()
  const [sample, setSample] = useState(initialstate)
  const [techtype, setTechType] = useState("")
  const [load, setLoad] = useState(false)
  const [showNotes, setShowNotes] = useState(false)
  const [notes_for_managers, setnotesForManager] = useState("")

  const handleChange = (key, value) => {
    setSample({ ...sample, [key]: value })
  }

  const handleSubmit = async e => {
    e.preventDefault()
    setLoad(true)
    
    // // First validate and check for notes
    // const validateResult = await apiClient.post(`/sample?validate=true`, sample)
    // if (!validateResult.ok) {
    //   setLoad(false)
    //   return dispatch(
    //     showModal({
    //       error: true,
    //       title: "Sample",
    //       message: validateResult.data.message
    //     })
    //   )
    // }

    // Fetch client data to check for notes
    await fetchClientData()
  }

  const fetchClientData = async () => {
    const result = await apiClient.get(`/client/by_barcode/${sample.barcode}`)
      setLoad(false)
    if (!result.ok) {
      return dispatch(
        showModal({
          error: true,
          title: "Sample",
          message: result.data.message
        })
      )
    }

    const Notes = result.data.result?.notes_for_managers || ""

    if (Notes) {
      setnotesForManager(Notes)
      setShowNotes(true)
    } else {
      await handleAssignSample()
    }
  }

  const handleAssignSample = async () => {
    setLoad(true)
    const result = await apiClient.post(`/sample/receive-sample/`, sample)
    setLoad(false)
    
    if (!result.ok) {
      return dispatch(
        showModal({
          error: true,
          title: "Sample",
          message: result.data.message
        })
      )
    }
    
    fetchData()
    onHide()
    return dispatch(
      showModal({
        error: false,
        title: "Sample Received",
        message: result.data.message
      })
    )
  }

  // Notes Popup Modal
  if (showNotes) {
    return (
      <Modal
        show={show}
        onHide={() => {
          setShowNotes(false)
          setLoad(false)
        }}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className=" " closeButton>
          <Modal.Title id="contained-modal-title-vcenter" className="text-center w-100">
            <HelpIcon style={{ fontSize: "55px", color: "#7C828C" }} />
          </Modal.Title>
        </Modal.Header>

        <form
          onSubmit={e => {
            e.preventDefault()
            handleAssignSample()
          }}
        >
          <Modal.Body>
            <h4 className="text-center">Manager Notes</h4>
            <p className="text-center">Please review the following notes before assigning the sample:</p>
            <div className="d-flex justify-content-center">
              <div className="bg-light p-3 rounded" style={{ maxWidth: "400px", width: "100%" }}>
                <p className="text-center mb-0">{notes_for_managers}</p>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="">
            {!load ? (
              <div className="d-flex justify-content-between gap-3 w-100">
                <Button 
                  variant="outlined" 
                  color="warning" 
                  className="px-5" 
                  onClick={() => {
                    setShowNotes(false)
                    setLoad(false)
                  }}
                >
                  Cancel
                </Button>
                <Button 
                  type="submit" 
                  variant="contained" 
                  className="btn_bg_secondery px-5"
                >
                  Assign Sample
                </Button>
              </div>
            ) : (
              <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
                <CircularProgress />
              </Box>
            )}
          </Modal.Footer>
        </form>
      </Modal>
    )
  }

  // Main Assign Sample Modal
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header className=" " closeButton>
        <Modal.Title id="contained-modal-title-vcenter" className="text-center w-100">
          <HelpIcon style={{ fontSize: "55px", color: "#7C828C" }} />
        </Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          <h4 className="text-center">Assign this Sample</h4>
          <p className="text-center">
            Assign this sample to a specific <br />
            technician.
          </p>

          <div className="row justify-content-center gap-2 my-2">
            <div className="col-12">
              <TextField
                required
                label="Barcode"
                // value={client.veterinarian}
                name="barcode"
                value={sample.barcode}
                onChange={e => handleChange("barcode", e.target.value)}
                variant="outlined"
                fullWidth
              />
            </div>
            <div className="col-12">
              <SelectOption
                style={{ width: "100%" }}
                data={[
                  { value: "TN", label: "Normal" },
                  { value: "PPTN", label: "PP Technician" },
                  { value: "EXP", label: "Exp Technician" }
                ]}
                id="outlined-basic"
                value={techtype}
                onChange={e => setTechType(e.target.value)}
                label="Technician Type"
                variant="outlined"
              />
            </div>
            <div className="col-12">
              <SelectDropdown
                label="Technician"
                sx={{ backgroundColor: "white" }}
                techType={techtype}
                value={sample.technician}
                name={"technician"}
                handleChange={handleChange}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          {!load ? (
            <Button
              type="submit"
              size="large"
              variant="contained"
              className=" btn_bg_secondery px-5"
            >
              Save
            </Button>
          ) : (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <CircularProgress />
            </Box>
          )}
        </Modal.Footer>
      </form>
    </Modal>
  )
}
function ReAssignModal({ fetchData, onHide, show, data }) {
  let initialstate = {
    technician: data.technician._id
  }
  const dispatch = useDispatch()
  const [sample, setSample] = useState(initialstate)
  const [techtype, setTechType] = useState(data.technician?.role || "")
  const [load, setLoad] = useState(false)
  const [showNotes, setShowNotes] = useState(false)
  const [notes_for_managers, setnotesForManager] = useState("")

  const handleChange = (key, value) => {
    setSample({ ...sample, [key]: value })
  }

  const handleSubmit = async e => {
    e.preventDefault()
    setLoad(true)
    
    // First check for client notes
    await fetchClientData()
  }

  const fetchClientData = async () => {
    // Get client data to check for notes
    const clientResult = await apiClient.get(`/client/${data.client._id}`)
       setLoad(false)
    if (!clientResult.ok) {
      return dispatch(
        showModal({
          error: true,
          title: "Sample",
          message: "Failed to fetch client data"
        })
      )
    }

    const Notes = clientResult.data.result?.notes_for_managers || ""

    if (Notes) {
      setnotesForManager(Notes)
      setShowNotes(true)
    } else {
      await handleReAssignSample()
    }
  }

  const handleReAssignSample = async () => {
    setLoad(true)
    const result = await apiClient.patch(`/sample/${data._id}/res-assign-sample/`, sample)
    setLoad(false)
    
    if (!result.ok) {
      return dispatch(
        showModal({
          error: true,
          title: "Sample",
          message: result.data.message
        })
      )
    }
    
    fetchData()
    onHide()
    return dispatch(
      showModal({
        error: false,
        title: "Sample Re-Assigned",
        message: "Sample has been successfully re-assigned"
      })
    )
  }

  // Notes Popup Modal
  if (showNotes) {
    return (
      <Modal
        show={show}
        onHide={() => {
          setShowNotes(false)
          setLoad(false)
        }}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className=" " closeButton>
          <Modal.Title id="contained-modal-title-vcenter" className="text-center w-100">
            <HelpIcon style={{ fontSize: "55px", color: "#7C828C" }} />
          </Modal.Title>
        </Modal.Header>

        <form
          onSubmit={e => {
            e.preventDefault()
            handleReAssignSample()
          }}
        >
          <Modal.Body>
            <h4 className="text-center">Manager Notes</h4>
            <p className="text-center">Please review the following notes before re-assigning the sample:</p>
            <div className="d-flex justify-content-center">
              <div className="bg-light p-3 rounded" style={{ maxWidth: "400px", width: "100%" }}>
                <p className="text-center mb-0">{notes_for_managers}</p>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="">
            {!load ? (
              <div className="d-flex justify-content-between gap-3 w-100">
                <Button 
                  variant="outlined" 
                  color="warning" 
                  className="px-5" 
                  onClick={() => {
                    setShowNotes(false)
                    setLoad(false)
                  }}
                >
                  Cancel
                </Button>
                <Button 
                  type="submit" 
                  variant="contained" 
                  className="btn_bg_secondery px-5"
                >
                  Re-Assign Sample
                </Button>
              </div>
            ) : (
              <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
                <CircularProgress />
              </Box>
            )}
          </Modal.Footer>
        </form>
      </Modal>
    )
  }

  // Main Re-Assign Sample Modal
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header className=" " closeButton>
        <Modal.Title id="contained-modal-title-vcenter" className="text-center w-100">
          <HelpIcon style={{ fontSize: "55px", color: "#7C828C" }} />
        </Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          <h4 className="text-center">Re-Assign this Sample</h4>
          <p className="text-center">
            Re-Assign this sample to a specific <br />
            technician.
          </p>

          <div className="row justify-content-center gap-2 my-2">
            <div className="col-12">
              <SelectOption
                style={{ width: "100%" }}
                data={[
                  { value: "TN", label: "Normal" },
                  { value: "PPTN", label: "PP Technician" },
                  { value: "EXP", label: "Exp Technician" }
                ]}
                id="outlined-basic"
                value={techtype}
                onChange={e => setTechType(e.target.value)}
                label="Technician Type"
                variant="outlined"
              />
            </div>
            <div className="col-12">
              <SelectDropdown
                label="Technician"
                sx={{ backgroundColor: "white" }}
                techType={techtype}
                value={sample.technician}
                name={"technician"}
                handleChange={handleChange}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          {!load ? (
            <Button
              type="submit"
              size="large"
              variant="contained"
              className=" btn_bg_secondery px-5"
            >
              Re-Assign
            </Button>
          ) : (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <CircularProgress />
            </Box>
          )}
        </Modal.Footer>
      </form>
    </Modal>
  )
}
const SelectDropdown = ({ name, value, handleChange, techType, ...otherProps }) => {
  const [data, setData] = useState([])
  const [page, setPage] = useState(1)
  const [count, setCount] = useState()
  const { request } = useApi(route => apiClient.get(route))
  useEffect(() => {
    fetchData(1)
  }, [techType])

  async function fetchData(pageNo = page) {
    const result = await request(`/auth/all-users-t/?page=${pageNo}&role=${techType}`)
    if (result.data.results)
      if (pageNo === 1) setData(result.data?.results)
      else setData([...data, ...result.data?.results])
    setPage(pageNo + 1)
    if (!count) setCount(result.data.count)
  }

  const handleScroll = event => {
    const { scrollTop, clientHeight, scrollHeight } = event.target
    if (scrollTop + clientHeight >= scrollHeight - 1) {
      if (count > data.length) fetchData()
    }
  }

  return (
    <SelectOption
      fieldNames={{ value: "_id", name: "name" }}
      required
      inputProps={{ maxLength: 150 }}
      id="outlined-name"
      value={value}
      onChange={e => handleChange(name, e.target.value)}
      size={"large"}
      data={data}
      fullWidth
      style={{ width: "100%" }}
      MenuProps={{
        PaperProps: {
          onScroll: handleScroll,
          style: {
            maxHeight: "300px",
            overflowY: "auto"
          }
        }
      }}
      {...otherProps}
    />
  )
}

export default SubmittedReport
